var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncrease = function SvgIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#increase_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6A89A6",
    d: "M22.666 21a.833.833 0 0 1 .098 1.66l-.098.007H9.333a.834.834 0 0 1-.098-1.661L9.333 21h13.333Zm0-4.167a.833.833 0 0 1 0 1.667h-7.5a.833.833 0 1 1 0-1.667h7.5Zm-13.63-3.189.241.126.287.158.159.09.346.203.187.113.396.252c.214.139.411.272.593.4l.339.242.152.114.268.205.219.173c.178.145.17.434-.017.586l-.217.171-.266.203-.313.228-.173.123-.38.259-.206.136c-.14.091-.276.177-.406.257l-.37.223-.332.19-.288.158-.242.125c-.211.108-.438-.03-.46-.277l-.033-.425-.03-.541-.015-.42-.008-.463v-.508l.01-.487.016-.44.02-.386.037-.472c.022-.264.27-.425.485-.317v.001Zm13.63-.977a.834.834 0 0 1 0 1.666h-7.5a.833.833 0 1 1 0-1.666h7.5Zm0-4.167a.833.833 0 0 1 0 1.667H9.333a.833.833 0 1 1 0-1.667h13.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "increase_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h20v20H6z"
  })))));
};
export default SvgIncrease;